<template>
  <form autocomplete="off">
    <div class="wrapper">
        <p class="title text-center" v-html="editTypeText"></p>
        <div class="content">
          <div v-if="type == 'password'" class="confirm-password-text text-center">{{ $t('form.currentPassword') }}</div>
          <div v-else class="confirm-password-text text-center">{{ $t('form.currentPasswordRequired')}}</div>
          <div class="from-inputs">
            <div class="m-d-gruop">
            
              <input autocomplete="false" name="hidden" type="text" style="display:none;">
              <vpInput
                :label="$t('common.password')"
                width="415"
                v-model="password"
                type="password"
                @input="changePassword"
                />
            </div>
            <div v-if="invalidPassword" class="err-wrapper"> {{ $t('validation.incorrectPw') }}</div>
          </div>
          <!-- <span @click="showPasswordVal()" class="showPassword" :class="{'mt-71' : invalidPassword}">
            <svg width="19" height="13" viewBox="0 0 19 13" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path fill-rule="evenodd" clip-rule="evenodd" d="M9.5 0C5.18182 0 1.49409 2.69533 0 6.5C1.49409 10.3047 5.18182 13 9.5 13C13.8182 13 17.5059 10.3047 19 6.5C17.5059 2.69533 13.8182 0 9.5 0ZM9.5 10.8332C7.11636 10.8332 5.18182 8.89184 5.18182 6.49984C5.18182 4.10784 7.11636 2.1665 9.5 2.1665C11.8836 2.1665 13.8182 4.10784 13.8182 6.49984C13.8182 8.89184 11.8836 10.8332 9.5 10.8332ZM6.90909 6.4999C6.90909 5.06124 8.06636 3.8999 9.5 3.8999C10.9336 3.8999 12.0909 5.06124 12.0909 6.4999C12.0909 7.93857 10.9336 9.0999 9.5 9.0999C8.06636 9.0999 6.90909 7.93857 6.90909 6.4999Z" :fill="colorVal"/>
            </svg>
          </span> -->
        </div>
        <!-- action btns  -->
        <hr class="h-line" />
        <div class="action-btns" style="width: 416px; margin:auto">
        <button type="button" class="submit-btn btn btn-primary d-flex align-items-center justify-content-center" size="md" @click="onSubmit" :disabled="getLoading || invalidPassword || !password">
          <i v-if="getLoading" class="bx bx-loader bx-spin font-size-16 align-middle mr-2 rounded"></i>
          <span>{{ $t('common.next')}}</span>
        </button>
        <button type="button" class="btn btn-outline-danger ml-32" @click="$bvModal.hide('validateUserPasswordModal')">
          {{ $t('common.cancel')}}
        </button>
        </div>  
    </div>
  </form>
  </template>
  
  <script>
  import { mapActions, mapGetters } from "vuex";
  export default {
    props: ["loggedInUser", 'type'],
    data() {
      return {
        user : null,
        submitted: false,
        password : null,
        editTypeText : '',
        colorVal :'#787878',
        invalidPassword : false,
      };
    },
    watch: {
      getModalState(state) {
        state && this.$bvModal.hide("checkUserPasswordModal");
      },
    },
    computed: {
      ...mapGetters("user", [
        "getLoading",
        "getUserFirstName",
        "getUserLastName",
        "getModalState",
        "getUserData",
        "getUserEmail",
        "getUserPhone",
      ]),
    },
    methods: {
      ...mapActions("user", ["updateUserNameAction", "resetState", "validateUserPassword"]),
      onSubmit() {
        this.submitted = true;
        this.validateUserPassword({
            email : this.getUserEmail ? this.getUserEmail : '',
            phone : this.getUserPhone ? this.getUserPhone : '',
            password : this.password
        }).then((res) => {
          console.log('res', res);
          if(this.type == 'email'){
            this.$bvModal.show('userEmail');
          }else if(this.type == 'phone'){
            this.$bvModal.show('userPhone');
          }else if(this.type == 'password'){
            this.$bvModal.show('userPassword');
          }
          this.$bvModal.hide('validateUserPasswordModal');
          this.submitted = false;
        }).catch((e) => {
          console.log('e', e);
          this.submitted = false;
          this.invalidPassword = true;
        });

      },
      showPasswordVal(){
          const passwordField = document.getElementById('password');
          if (passwordField.type === "password") {
              passwordField.type = "text";
              this.colorVal = '#103F5E'
          } else {
              passwordField.type = "password";
              this.colorVal = '#787878'
          }
      },
      changePassword(){
        this.invalidPassword = false;
      },
    },
    beforeMount() {
        console.log('getUserData', this.getUserData);
      this.resetState();
      if(this.type == 'email'){
        this.editTypeText = this.$t('form.editEmail');
      }else if(this.type == 'phone'){
        this.editTypeText = this.$t('form.editPhone');
      }else if(this.type == 'password'){
        this.editTypeText = this.$t('form.editPassword')
      }
    },
  };
  </script>
  
  <style lang="scss" scoped>
  .wrapper {
    .cursor-not-allowed{
      cursor: not-allowed;
    }
  }
  </style>
  <style lang="scss">
  div#validateUserPasswordModal___BV_modal_content_ {
    button.submit-btn.btn.btn-primary{
      color: #ffffff!important;
      font-size: 16px;
      margin-right: 0px!important;
      font-weight: 400;
    }
    .modal-content .modal-body .wrapper .title {
      font-size: 17px;
      font-weight: 700;
      font-family: "lato";
      margin-bottom: 40px;
      color: #000000;
    }
    .content {
      width: 416px;
      margin: auto;
      .err-wrapper div{
        margin: 8px 0px 0px 0px!important;
      }
      .err-wrapper{
        padding-left: 0px!important;
        margin-top: 8px;
        
        margin-left: 20px!important;
        .error-value{
          font-weight: 600!important;
        }
      }
      .from-inputs {
        width: 416px;
      }
      .m-d-gruop > label{
        color: #787878!important;
        opacity: 1!important;
      }
      .form-control:valid ~ label{
        font-weight: 700!important;
        opacity: 1!important;
        color: #103f5e!important;
      }
      .form-control:focus ~ label{
        font-weight: 700!important;
        opacity: 1!important;
        color: #103f5e!important;
      }
      .m-d-gruop > input{
        opacity: 1!important;
        color: rgba(0, 0, 0, 0.87)!important;
      }
      .input-wrapper{

        .label {
            font-size: 16px;
            font-family: "lato";
            margin-right: 0px!important;
            font-weight: 400;
            color: #787878;
            margin-right: 8px!important;
            opacity: 1!important;
            margin-left: 20px;
        }
        .text-value{
            font-size: 16px;
            font-family: "lato";
            line-height: 17px;
            margin-right: 0px!important;
            font-weight: 700;
            color: #4A4A4A;
            margin-bottom: 0px!important;
        }
      }
      .sep-change-name{
        height: 1px;
        width: 416px;
        background: #707070;
        opacity: .15;
        margin-bottom: 32px;
        margin-top: 32px;
      }

    }

    .confirm-password-text{
        font-size: 16px;
        font-family: "lato";
        font-weight: 400;
        color: #4A4A4A;
        margin-bottom: 24px !important;
    }
  
    .h-line{
      margin-top: 40px !important;
      margin-bottom: 24px;
    }

    .showPassword {
      float: right;
      margin-top: -42px;
      margin-right: 21px;
      font-weight: 400;
      cursor: pointer;
    }

    .m-d-gruop > input {
      width: 90%;
    }
    .mt-71{
      margin-top:-71px
    }
    .action-btns {
      .submit-btn {
          margin-inline-end: 32px;
      }
    }
  }
</style>
  